import React from 'react';
import {
    DataGridPro,
} from '@mui/x-data-grid-pro';


export default function HeroProductListView({ bundle }) {

    const columns = [
        {
            field: 'thumbnail',
            headerName : '',
            flex: 0,
            renderCell: params => (<img alt="" style={{ width : 30, height : 30}} src={params.row.productData?.presentation?.medias?.find(m => m.type === 'image' && m.section === 'thumbnail')?.url || ''}/>)
        },
        {
            field: 'productId',
            headerName: 'ID',
            flex: 1,
        },
        {
            field: 'productType',
            headerName: 'Type',
            flex: 1,
            valueGetter : params => titleCase(params.row.type || 'PRODUCT')
        },
        {
            field: 'name',
            headerName: 'Name',
            flex: 1,
        },
        {
            field: 'status',
            headerName: 'Status',
            flex: 1,
            valueGetter : params => titleCase(params.row.productData?.status || '-')

        },
        {
            field: 'category',
            headerName: 'Category',
            flex: 1,
            valueGetter : params => titleCase(params.row.productData?.category || '-')

        },
        {
            field: 'cities',
            headerName: 'Cities',
            flex: 1,
            valueGetter : params => params.row.productData?.wheres?.map?.(w => w.name).join(', ')
        }

    ];


    return (
        <DataGridPro
            rows={bundle.heroProducts || []}
            columns={columns}
            pagination={true}
            pageSize={10}
            getRowId={row => row.productId}
            sx={{
                height: '800px',
                '.MuiDataGrid-columnHeaders': {
                    fontWeight: 'bold',
                    fontSize: 14,
                    color: 'rgb(0,0,0)',
                    backgroundColor: 'rgb(244,246,248)',
                },
                '.MuiTablePagination-selectLabel': {
                    marginBottom: '0px',
                },
                '.MuiTablePagination-displayedRows': {
                    marginBottom: '0px',
                },
                '.MuiPaper-root.div.span': {
                    color: 'blue',
                },
            }}
        />
    );

}


function titleCase(str) {
    var splitStr = str.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
    }
    // Directly return the joined string
    return splitStr.join(' '); 
 }
 